import React from 'react'
import { BsCpu, BsPerson, BsPersonFillGear, BsPersonUp } from 'react-icons/bs'
import { MdChevronRight } from 'react-icons/md'

export default function AgentPricing() {
  return (
    <div className='container'>
      <h3 className='text-center text-muted'>قیمت ها</h3>
      <br/>
      <div className='row justify-content-center'>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><BsPerson size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>کارمند</h5>
              <br/>
              <p className='brand-p bold'>مناسب برای انجام عملیات روزانه بدون نیاز به درک و تحلیل خاص با قدرت تصمیم گیری محدود</p>
              <hr/>
              <div className='text-muted bold'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>توسعه و استقرار</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی (تیکت)</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پردازشگر (یک ماه)</p>
                  <p>۲.۵ میلیون تومان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>میانگین زمان آماده سازی</p>
                  <p>۷ روز</p>
                </div>
              </div>
            </div>
            <br/>
          </div>
        </div>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><BsPersonFillGear size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>کارشناس</h5>
              <br/>
              <p className='brand-p bold'>قدرتمند در تحلیل و تصمیم گیری و منعطف در مواجهه با شرایط متغیر محیط پیرامون</p>
              <hr/>
              <div className='text-muted bold'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>توسعه و استقرار</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی (تیکت)</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پردازشگر (یک ماه)</p>
                  <p>۵ میلیون تومان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>میانگین زمان آماده سازی</p>
                  <p>۱۵ روز</p>
                </div>
              </div>
            </div>
            <br/>
          </div>
        </div>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><BsPersonUp size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>ارشد</h5>
              <br/>
              <p className='brand-p bold'>یک متخصص حرفه ای با دانش وسیع و قدرت عمل بالا برای حل چالشهایی بزرگ</p>
              <hr/>
              <div className='text-muted bold'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>توسعه و استقرار</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی (تیکت)</p>
                  <p className='bold text-primary'>رایگان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پردازشگر (یک ماه)</p>
                  <p>۱۰ میلیون تومان</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>میانگین زمان آماده سازی</p>
                  <p>۳۰ روز</p>
                </div>
              </div>
            </div>
            <br/>
          </div>
        </div>
        <div className='col-md-3 p-2'>
          <div className='brand-card'>
            <div className='text-center'>
              <div>
                <span className='text-primary'><BsCpu size={"35px"}/></span>
              </div>
              <br/>
              <h5 className='bold text-primary'>سازمانی</h5>
              <br/>
              <p className='brand-p bold'>گروهی از عامل های هوشمند ارشد با راهبری واحد و با توان و مقیاس پردازشی وسیع.</p>
              <hr/>
              <div className='text-muted bold'>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>ساخت و استقرار</p>
                  <p>قراردادی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پشتیبانی</p>
                  <p className='bold'>قراردادی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>پردازشگر (یک ماه)</p>
                  <p>قراردادی</p>
                </div>
                <div className='d-flex flex-row justify-content-between align-items-center'>
                  <p>میانگین زمان آماده سازی</p>
                  <p>قراردادی</p>
                </div>
              </div>
            </div>
            <br/>
          </div>
        </div>
      </div>
      <div className='d-flex flex-row justify-content-end'>
        <p className='text-muted'>به مبالغ فوق ۱۰ درصد مالیات بر ارزش افزوده اضافه می گردد
          <span className='m-2'><MdChevronRight/></span>
        </p>
      </div>
    </div>
  )
}
